import React, {useState} from 'react';
import clsx from 'clsx';

import styles from './styles.module.scss';
import {TopElement} from '../TopElement';
import {featuresLinks} from '../../../constants/links';
import {Time, Webhook1, DiscordSmall} from '../../../assets';
import flag from '../../../assets/img/flag.png';

const data = [
  {
    id: '1',
    avatar: <Webhook1 />,
    name: 'Spidey Bot',
    status: 'Strict',
    info: [
      {icon: <Time />, text: 'Member since:'},
      {icon: <DiscordSmall />, text: '25 Aug 2021'},
      {icon: <img src={flag} alt="icon" />, text: '25 Aug 2021'},
    ],
  },
  {
    id: '2',
    avatar: <Webhook1 />,
    name: 'DM me exclusive mint',
    status: 'Wildcard',
    info: [
      {icon: <Time />, text: 'Member since:'},
      {icon: <DiscordSmall />, text: '25 Aug 2021'},
      {icon: <img src={flag} alt="icon" />, text: '25 Aug 2021'},
    ],
  },
  {
    id: '3',
    avatar: <Webhook1 />,
    name: 'claim airdrop',
    status: 'Fuzzy',
    info: [
      {icon: <Time />, text: 'Member since:'},
      {icon: <DiscordSmall />, text: '25 Aug 2021'},
      {icon: <img src={flag} alt="icon" />, text: '25 Aug 2021'},
    ],
  },
  {
    id: '4',
    avatar: <Webhook1 />,
    name: 'Mint info',
    status: 'Fuzzy',
    info: [
      {icon: <Time />, text: 'Member since:'},
      {icon: <DiscordSmall />, text: '25 Aug 2021'},
      {icon: <img src={flag} alt="icon" />, text: '25 Aug 2021'},
    ],
  },
  {
    id: '5',
    avatar: <Webhook1 />,
    name: 'Spidey Bot',
    status: 'Wildcard',
    info: [
      {icon: <Time />, text: 'Member since:'},
      {icon: <DiscordSmall />, text: '25 Aug 2021'},
      {icon: <img src={flag} alt="icon" />, text: '25 Aug 2021'},
    ],
  },
];

export const FakeDetection = () => {
  const [list, setList] = useState(data);

  const deleteItem = (id) => {
    const newList = list.filter((item) => item.id !== id);
    setList(newList);
  };

  return (
    <div className={styles.wrapper}>
      <TopElement
        title="Fake Detection"
        subTitle="Also known as impersonator detection. The algorithm, created in October 2021, has been improved and can now detect fake accounts accurately. Furthermore, the manager can create a personal dictionary of banned nicknames, which the bot will use to ban users with those names. In addition to the personal dictionary, a global dictionary that is constantly updated can be linked."
        labelTitle="Fake Detection Tutorial"
        labelLInk={featuresLinks.fakeDetection}
      />
      <div className={styles.block}>
        <div className={styles.tag}>
          Fake accounts of <span className={styles.tagMod}>{`Cool Discord server <3`}</span>
        </div>
        <div className={styles.wrapperData}>
          {list.map((item) => (
            <Item key={item.id} data={item} onClick={deleteItem} />
          ))}
        </div>
      </div>
    </div>
  );
};

const Item = ({data, onClick}) => {
  return (
    <div className={styles.item}>
      <div className={styles.itemInner}>
        <div className={styles.avatar}>{data.avatar}</div>
        <div className={styles.right}>
          <div className={styles.name}>
            {data.name}
            <span className={styles.nameTag}>{data.status}</span>
          </div>
          <div className={styles.info}>
            {data.info.map((item, i) => (
              <div
                className={clsx(styles.infoItem, {
                  [styles.last]: i === data.info.length - 1,
                })}
                key={i}>
                {item.icon}
                <span className={styles.infoText}>{item.text}</span>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.button} onClick={() => onClick(data.id)}>
          Ban User
        </div>
      </div>
    </div>
  );
};
